// src/Dashboard/pages/user/DashboardUser/components/EmptyState.jsx

import React from "react";

export default function EmptyState({
  icon: Icon,
  title = "Aucune donnée",
  description,
  action,
}) {
  return (
    <div className="flex min-h-[220px] flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-slate-50/70 p-8 text-center dark:border-slate-700 dark:bg-slate-900/40">
      {Icon && (
        <span className="mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-xl text-slate-500 shadow-sm dark:bg-slate-800 dark:text-slate-300">
          <Icon />
        </span>
      )}

      <h3 className="text-base font-bold text-slate-900 dark:text-white">
        {title}
      </h3>

      {description && (
        <p className="mt-1 max-w-md text-sm leading-6 text-slate-500 dark:text-slate-400">
          {description}
        </p>
      )}

      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}